import DefaultErrorPage from './DefaultErrorPage';
import GenericErrorPage from './GenericErrorPage';

export default GenericErrorPage;

export { DefaultErrorPage };
